<template>
  <div :style="'width:' + width + 'px !important'">
    <video ref="plyr" class="plyr" id="player" playsinline controls></video>
  </div>
</template>

<script>
import Plyr from "plyr/dist/plyr";
import "plyr/dist/plyr.css";
const plyrsvg = require("plyr/dist/plyr.svg");

export default {
  components: {
    // appVideoPlayer,
  },
  props: {
    playList: Array,
    autoPlay: Boolean,
    hideVolume: Boolean,
    width: String,
  },
  data() {
    return {
      trackNumber: 0,
      player: {},
      playerType: "video",
      options: {
        controls: [
          // "play-large",
          "play",
          // "progress",
          "mute",
          "volume",
          "fullscreen",
        ],
        volume: 0.5,
        iconUrl: plyrsvg,
        blankVideo: "",
      },
    };
  },
  mounted() {
    if (this.hideVolume) {
      this.removeVoumeControls();
    }

    this.player = new Plyr(this.$refs.plyr, this.options);
    this.player.config.hideControls = false;
    const _this = this;
    this.setFirstTrack();
    this.player.on("ended", _this.ended);
  },
  methods: {
    ended(evt) {
      console.log(evt);
      ++this.trackNumber;
      if (this.trackNumber < this.playList.length) {
        this.setNextTrack();
      } else {
        this.setFirstTrack();
      }
    },
    setFirstTrack() {
      this.player.pause();
      this.trackNumber = 0;
      this.setSource(`${this.video}#t=0.5`, "video/mp4");
    },
    setNextTrack() {
      //this.player.pause();
      //this.player.config.controls = [];
      this.setSource(this.video, "video/mp4");
      this.player.play();
    },
    setSource(sourceFile, type) {
      this.player.source = {
        type: this.playerType,
        sources: [{ src: sourceFile, type: type }],
      };
    },
    removeVoumeControls() {
      this.options.controls = this.options.controls.filter(
        (r) => r !== "mute" && r !== "volume"
      );
    },
  },
  computed: {
    video() {
      return this.playList[this.trackNumber];
    },
  },
  watch: {
    playList(newValue, oldValue) {
      if (
        newValue &&
        (!oldValue || oldValue.length === 0 || newValue != oldValue)
      ) {
        this.setFirstTrack();
      }
    },
  },
};
</script>

<style></style>
